export default "__VITE_ASSET__BlhBEGoU__"